export default "__VITE_ASSET__5cb7e023__"